import { useDescope, useSession } from "@descope/react-sdk";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

import Unauthorized from "./components/global/components/Unauthorized";
import pages from "./constants/pages";
import useAuthorization from "./hooks/useAuthorization";
import useSessionManager from "./hooks/useSessionManager";
import { resetNavigationState } from "./redux/navigationSlice";
import {
	setEmail, setFirstName, setGroups, setLastName, setOrgId,
	setPermissions, setPhone, setRoles, setUserId
} from "./redux/userSlice";

const ProtectedRoute = ({ permissions, isInclusive }) => {
	const isAuthorized = useAuthorization(permissions, isInclusive);
	const [isAuthorizing, setIsAuthorizing] = useState(true);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { logout } = useDescope();
	const { isAuthenticated, isSessionLoading } = useSession();
	
	useSessionManager();

	const logoutUser = async () => {
		try {
			logout();
		} catch (e) {
			console.error(e);
		}

		dispatch(setUserId(null));
		dispatch(setEmail(null));
		dispatch(setFirstName(null));
		dispatch(setGroups([]));
		dispatch(setLastName(null));
		dispatch(setPermissions([]));
		dispatch(setPhone(null));
		dispatch(setRoles([]));
		dispatch(setOrgId(null));
		dispatch(resetNavigationState());
		navigate(pages.login);
	};

	useEffect(() => {
		if (isSessionLoading) {
			return;
		}
		if (!isAuthenticated) {
			logoutUser();
			return;
		}
		setIsAuthorizing(false);
	}, [isSessionLoading, isAuthenticated]);

	if (isSessionLoading) {
		return (
			<></>
		);
	} else if (isAuthenticated && !isAuthorized && !isAuthorizing) {
		return (
			<Unauthorized />
		);
	} else if (isAuthenticated && isAuthorized) {
		return (
			<div style={{ height: "100%" }}>
				<Outlet />
			</div>
		);
	}
};

export default ProtectedRoute;